// src/Components/Admin/RoleAndIdentitySwitcher.js
import React, { useContext, useEffect, useMemo, useState } from 'react';
import GeneralContext from '../GeneralContext/GeneralContext';
import { Box } from '@mui/system';
import {
  Select, MenuItem, TextField, Stack, Typography, ListSubheader,
  Accordion, AccordionSummary, AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PageButtonBlack from '../GeneralComponents/PageButtonBlack';
import PageButtonWhite from '../GeneralComponents/PageButtonWhite';
import axios from "../../api/axios";

import {
  ROLE_LABELS,
  ALL_ROLE_IDS,
} from "../../Constants/Constants";

const RoleAndIdentitySwitcher = () => {
  const {
    userSesion,
    effectiveRoleId,
    changeEffectiveRole,
    updateUserIdentity,
    resetUserIdentityOverrides,
    isAdmin,
    serverUser,
    reloadChildren, 
  } = useContext(GeneralContext);

  // Hooks SIEMPRE arriba
  const roles = userSesion?.roles ?? [];
  const ownedRoleIds = roles.map(r => r.role_id);
  const unownedConstantRoleIds = ALL_ROLE_IDS.filter(id => !ownedRoleIds.includes(id));

  // único campo para rut/id
  const [docValue, setDocValue] = useState('');

  useEffect(() => {
    setDocValue(userSesion?.rut ?? userSesion?.id ?? '');
  }, [userSesion?.rut, userSesion?.id]);

  const currentRoleName = useMemo(() => {
    const fromServer = userSesion?.roles[0].nombre_rol;
    if (fromServer) return fromServer;

    
    if (effectiveRoleId != fromServer) {
      return ROLE_LABELS[effectiveRoleId] ?? `Rol #${effectiveRoleId}`;
    }
    return 'Original (backend)';
  }, [userSesion]);

  if (!userSesion) return null;

  const badgeStyle = {
    fontSize: 12, padding: '2px 8px', borderRadius: 12,
    background: isAdmin ? '#DCFCE7' : '#FEE2E2',
    color: isAdmin ? '#065F46' : '#991B1B',
    border: `1px solid ${isAdmin ? '#86EFAC' : '#FCA5A5'}`
  };

  const fetchData = async (rut) => {
    try {

        const userInfo = await axios.getAdminUserData(rut);
        const data = userInfo?.data;
        
        updateUserIdentity(data);
        reloadChildren?.(); 
        
    } catch (e) {
      console.error("Error cargando info usuario:", e);
    } finally {
      //setLoadingTable(false);
    }


  };

  // Estilos reutilizables
  const cardStyle = { border: '1px solid #e5e7eb', borderRadius: 8, background: '#fafafa' };

  return (
    <Accordion disableGutters defaultExpanded sx={cardStyle}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
          <Typography sx={{ fontWeight: 700 }}>
            Switch de roles y ruts
          </Typography>
          <span style={badgeStyle}>{isAdmin ? 'Admin (original)' : 'No admin (original)'}</span>
          <Typography variant="body2" sx={{ ml: 1, color: '#6b7280' }}>
            Rol actual: <strong>{currentRoleName}</strong>
          </Typography>
          {!!(userSesion?.rut || userSesion?.id) && (
            <Typography variant="body2" sx={{ ml: 1, color: '#6b7280' }}>
              RUT/ID: <strong>{userSesion?.rut ?? userSesion?.id}</strong>
            </Typography>
          )}
        </Box>
      </AccordionSummary>

      <AccordionDetails>
        <Box sx={{ display: 'grid', gap: 2 }}>
          



          <Typography variant="caption" sx={{ color: '#6b7280' }}>
            Actual: <strong>{currentRoleName}</strong>
          </Typography>

          {/* Único input para RUT/ID */}
          <TextField
            size="small"
            label="RUT / ID"
            placeholder="11111111-1"
            value={docValue}
            onChange={(e) => setDocValue(e.target.value)}
          />

          <Stack direction="row" spacing={1}>
            <PageButtonBlack
              width="7rem"
              onClick={() => {
                // setea AMBOS con el mismo valor
                fetchData(docValue);
              }}
            >
              Guardar
            </PageButtonBlack>
            <PageButtonWhite
              width="9rem"
              onClick={() => {
                resetUserIdentityOverrides();
                fetchData(serverUser.id);
              }}
            >
              Restaurar
            </PageButtonWhite>
          </Stack>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default RoleAndIdentitySwitcher;
